import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/brand";

export const Testimonials = () => {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-36 bg-[#0a0a0a] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#facc15]" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
                Avaliações dos Clientes
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
              Avaliação média
              <span className="italic text-[#facc15]"> 5,0/5,0</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <div className="flex items-center gap-2 mb-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  size={22}
                  className="fill-[#facc15] text-[#facc15]"
                  strokeWidth={1}
                />
              ))}
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed">
              Clientes em Florianópolis, São José e Palhoça aprovam — desde
              o atendimento até a entrega final.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#050505] p-10 min-h-[320px] flex flex-col justify-between group hover:bg-[#0a0a0a] transition-colors"
            >
              <Quote
                size={36}
                strokeWidth={1}
                className="text-[#facc15]/40 group-hover:text-[#facc15] transition-colors"
              />
              <p className="my-6 font-display text-xl lg:text-2xl leading-snug text-white italic">
                “{t.quote}”
              </p>
              <div className="flex items-center justify-between pt-6 border-t border-white/10">
                <div>
                  <p className="font-display text-lg text-white">{t.name}</p>
                  <p className="text-xs uppercase tracking-[0.22em] text-zinc-500 mt-1">
                    {t.city}
                  </p>
                </div>
                <div className="flex items-center gap-1">
                  {Array.from({ length: t.rating }).map((_, idx) => (
                    <Star
                      key={idx}
                      size={14}
                      className="fill-[#facc15] text-[#facc15]"
                      strokeWidth={1}
                    />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
